import {
  HomeWork1,
  HomeWork2,
  HomeWork3,
  HomeWork4,
  HomeWork5,
  // PMAN1,
  // PMAN2,
  // SEO1,
  // SEO2,
  SMM1,
  SMM2,
  // CW1,
  // CW2,
  QA1,
  QA2,
  EM1,
  EM2,
  // SS1,
  // SS2,
  // KM1,
  // KM2,
  AI1,
  AI2,
  UI1,
  UI2,
  BD1,
  BD2,
  PD1,
  PD2,
  PW1,
  PW2,
  PW3,
  PW4,
  PW5,
  PW6,
  PW7,
  PW8,
  PW9,
  PW10,
  PW11,
  PW12,
  PW13,
  PW14,
  PW15,
  PW16,
  PW17,
  PW18,
  aboutSlider1,
  aboutSlider2,
  aboutSlider3,
  aboutSlider4,
  aboutSlider5,
  aboutSlider6,
  aboutSlider7,
  aboutSlider8,
  aboutValues1,
  aboutValues2,
  aboutValues3,
  aboutValues4,
} from "../assets/images";

import { ReactComponent as Audience } from "../assets/svg/Target-audience.svg";
import { ReactComponent as User } from "../assets/svg/User-Interview.svg";
import { ReactComponent as UserSurvey } from "../assets/svg/User-survey.svg";
import { ReactComponent as WebDesign } from "../assets/svg/Web-Design.svg";
import { ReactComponent as Process } from "../assets/svg/Process.svg";
import { ReactComponent as Ideas } from "../assets/svg/Ideas.svg";

export const NavLinks = [
  {
    id: 1,
    title: "About Us",
    url: "/about-us",
  },
  {
    id: 2,
    title: "Case Studies",
    url: "/case-studies",
  },
  {
    id: 3,
    title: "Our Process",
    url: "/our-process",
  },
  // {
  //   id: 6,
  //   title: "Pricing",
  //   url: "https://pricing.radiksez.com/",
  //   target: "_blank",
  // },

  {
    id: 4,
    title: "Careers",
    url: "/careers",
  },

  {
    id: 5,
    title: "Blogs",
    url: "/blogs",
  },
];

// Home Work Section
export const slidesData1 = [
  HomeWork1,
  HomeWork2,
  HomeWork3,
  HomeWork4,
  HomeWork5,
];

export const slidesData2 = [PW7, PW8, PW9, PW10, PW11, PW12];
export const slidesData3 = [PW1, PW2, PW3, PW4, PW5, PW6];
export const slidesData4 = [PW13, PW14, PW15, PW16, PW17, PW18];

// Home Offer Section
export const SkillData = [
  {
    id: 1,
    title: "Branding & Creative Design",
    answer:
      "Crafting compelling brand identities and creative designs that resonate with your audience and leave a lasting impression.",
  },
  {
    id: 2,
    title: "Social Media Management",
    answer:
      "Strategically managing your social media platforms to enhance brand presence, engage audiences, and drive meaningful interactions.",
  },
  {
    id: 3,
    title: "Web Development Solutions",
    answer:
      "Building tailored websites and web applications to meet your specific needs, focusing on usability, functionality, and scalability.",
  },
  {
    id: 4,
    title: "Data Analytics & Management Services",
    answer:
      "Leveraging data insights to inform decision-making, optimize processes, and drive business growth through efficient data collection, analysis, and management.",
  },
  {
    id: 5,
    title: "Comprehensive Digital Marketing Strategies",
    answer:
      "Implementing targeted digital marketing strategies to expand reach, generate leads, and maximize ROI across various online channels.",
  },
];

// FAQ Section
export const FaqData = [
  {
    id: 1,
    title: "What types of services do you offer?",
    answer: (
      <>
        We offer a wide range of outsourcing services, including web
        development, social media management, digital marketing, seo
        optimization, data entry, customer relationship management, brand
        design, knowledge management, etc.
      </>
    ),
  },

  {
    id: 2,
    title:
      "What are the benefits of using your agency instead of hiring directly?",
    answer: (
      <>
        → <strong>Reduced costs</strong>: We can provide access to skilled
        talent at competitive rates, potentially saving you money compared to
        in-house hiring.
        <br />
        <br />→ <strong>Access to a wider talent pool</strong>: Find the perfect
        expertise regardless of location and the hassle of hiring.
        <br />
        <br />→ <strong>Expertise and experience</strong>: Benefit from our
        team&apos;s experience and knowledge in managing outsourced projects.
      </>
    ),
  },

  {
    id: 3,
    title: "How do you ensure the quality of the work delivered?",
    answer: (
      <>
        We implement a multi-pronged approach:
        <br /> <br />→ <strong>Rigorous vetting process:</strong> Only qualified
        and experienced professionals join our talent pool.
        <br />
        <br />→ <strong>Project management expertise:</strong>Our dedicated
        project managers ensure clear communication, task delegation, and
        quality control throughout the project.
        <br />
        <br />→ <strong>Regular progress reports and revisions:</strong> You can
        stay involved and request revisions throughout the process.
        <br />
      </>
    ),
  },

  {
    id: 4,
    title: " What happens if I'm not satisfied with the work?",
    answer: (
      <>
        We have a clear revision and feedback process and are committed to
        ensuring your satisfaction. If you have any concerns, please don&apos;t
        hesitate to communicate with your dedicated project manager.
      </>
    ),
  },

  {
    id: 5,
    title: "How do I get started?",
    answer: (
      <>
        We recommend contacting us for a free consultation meeting. During the
        call, we will discuss your specific needs and answer any further
        questions you may have.
      </>
    ),
  },
];

// About Slider section
export const sliderImages = [
  { src: aboutSlider1, width: 324, height: 438, alt: "aboutSlider1" },
  { src: aboutSlider2, width: 432, height: 306, alt: "aboutSlider2" },
  { src: aboutSlider3, width: 324, height: 438, alt: "aboutSlider3" },
  { src: aboutSlider4, width: 432, height: 306, alt: "aboutSlider4" },
  { src: aboutSlider5, width: 324, height: 438, alt: "aboutSlider5" },
  { src: aboutSlider6, width: 432, height: 306, alt: "aboutSlider6" },
  { src: aboutSlider7, width: 432, height: 306, alt: "aboutSlider7" },
  { src: aboutSlider8, width: 432, height: 306, alt: "aboutSlider8" },
];

// About Values Section
export const valuesData = [
  {
    img: aboutValues1,
    titleUp: "Transparent",
    titleDown: "Communication",
    title: "Transparent Communication",
    description:
      "We prioritize open dialogue, ensuring clients are informed at every turn. Our clear communication fosters trust and alignment, enriching collaboration.",
  },
  {
    img: aboutValues2,
    titleUp: "Precision",
    titleDown: "Management",
    title: "Precision Management",
    description:
      "Our meticulous planning and execution ensure project success. Deadlines are met, objectives achieved, and complexities managed seamlessly, guaranteeing client satisfaction.",
  },
  {
    img: aboutValues3,
    titleUp: "Meticulous",
    titleDown: "Detail",
    title: "Meticulous Detail",
    description:
      "We obsess over details, perfecting design elements to deliver exceptional outcomes. From aesthetics to functionality, our dedication shines through in every pixel.",
  },
  {
    img: aboutValues4,
    titleUp: "Innovative",
    titleDown: "Excellence",
    title: "Innovative Excellence",
    description:
      "We thrive on innovation, pushing creative boundaries. By blending cutting-edge trends and strategic insights, we consistently deliver designs that stand at the forefront of excellence.",
  },
];

export const ValuesItemData = [
  {
    icon: <Audience className="contents-items-img" />,
    title: "Innovation",
    text: "We thrive on fresh ideas, driving us to pioneer solutions that redefine norms and position us as a trailblazing team!",
  },
  {
    icon: <User className="contents-items-img" />,
    title: "Collaboration",
    text: "Diverse viewpoints unite in seamless collaboration, nurturing a rich ecosystem of creativity, ensuring we deliver excellence!",
  },
  {
    icon: <Process className="contents-items-img" />,
    title: "Empathy",
    text: "Diverse viewpoints unite in seamless collaboration, nurturing a rich ecosystem of creativity, ensuring we deliver excellence!",
  },
  {
    icon: <UserSurvey className="contents-items-img" />,
    title: "Excellence",
    text: "Striving for excellence is our hallmark, propelling us to craft extraordinary work that showcases our team's exceptional dedication and competence.",
  },
  {
    icon: <Ideas className="contents-items-img" />,
    title: "Adaptability",
    text: "Thriving amidst change showcases our flexibility, enhancing our ability to swiftly navigate challenges, cementing our status as a resilient and agile team.",
  },
  {
    icon: <WebDesign className="contents-items-img" />,
    title: "Accountability",
    text: "Ownership breeds trust; our commitment to meeting and exceeding expectations amplifies our reputation as a reliable and accomplished team.",
  },
];

export const ValuesTeamData = [
  {
    icon: <Audience className="contents-items-img" />,
    title: "Accelerated Growth",
    text: "We craft personalized learning journeys, offer mentorship, and empower you to set and surpass career goals, fostering rapid professional development.",
  },
  {
    icon: <User className="contents-items-img" />,
    title: "Supportive Community",
    text: "We expose you to diverse projects, encouraging cross-domain exploration, cultivating adaptability, and enriching your skill set for dynamic growth.",
  },
  {
    icon: <Process className="contents-items-img" />,
    title: "Supportive Community",
    text: "We nurture collaboration, communication, knowledge sharing, and relationships to empower every team member in a supportive environment.",
  },
  {
    icon: <UserSurvey className="contents-items-img" />,
    title: "Recognition",
    text: "We value your contributions and achievements, spotlighting your accomplishments to fuel motivation and affirm the impact you bring to our team.",
  },
  {
    icon: <Ideas className="contents-items-img" />,
    title: "Shared Success",
    text: "We believe in collective success, fostering a culture where shared goals, teamwork, and mutual support lead to accomplishments that resonate throughout the team.",
  },
  {
    icon: <WebDesign className="contents-items-img" />,
    title: "Future-Focused",
    text: "We drive innovation, keeping you engaged with cutting-edge projects, ensuring your work directly shapes our forward-looking approach and paves the way for your progress.",
  },
];

export const AboutItemData = [
  {
    icon: <Audience className="contents-items-img" />,
    title: "User-centric Core",
    text: "People are first, always. We immerse ourselves in your users' perspectives, shaping designs that resonate and drive meaningful interactions.",
  },
  {
    icon: <User className="contents-items-img" />,
    title: "Expert Team",
    text: "Our skilled designers bring diverse expertise, ensuring a holistic approach to every project for superior results.",
  },
  {
    icon: <Process className="contents-items-img" />,
    title: "Strategic Innovation",
    text: "We don't merely follow trends; rather, we help to define them. Our designs are driven by insights, which results in experiences that have an impact.",
  },
  {
    icon: <UserSurvey className="contents-items-img" />,
    title: "Data-Driven Decisions",
    text: "People are first, always. We immerse ourselves in your users' perspectives, shaping designs that resonate and drive meaningful interactions.",
  },
  {
    icon: <Ideas className="contents-items-img" />,
    title: "Transparent Process",
    text: "Our open communication ensures you're informed every step, fostering trust and confidence in the design journey.",
  },
  {
    icon: <WebDesign className="contents-items-img" />,
    title: "Responsive Agility",
    text: "Our flexible structure allows us to adapt swiftly, ensuring your designs remain responsive to changing user needs.",
  },
];

export const specialLayoutContent = [
  {
    images: [UI1, UI2],
    items: [
      {
        title: "Business",
        subTitle: "Strategy",
        goals: [
          "Business Goal",
          "Mission",
          "Target",
          "Value proposition",
          "SWOT analysis",
          "Business Model canvas",
        ],
      },
      {
        title: "Research",
        goals: [
          "Competitive Analysis",
          "User Interviews",
          "Journey Mapping",
          "Value proposition",
        ],
      },
      {
        title: "Define",
        goals: [
          "UX Strategy",
          "Information Architecture",
          "User Flows",
          "Visual Direction",
        ],
      },
      {
        title: "Design",
        goals: [
          "Wireframe",
          "Clickable Prototypes",
          "Visual Design",
          "Design System",
        ],
      },
      {
        title: "Evaluate",
        goals: [
          "A/B Testing",
          "Metrics Analysis",
          "UX Audit",
          "Usability Testing",
          "User Surveys",
        ],
      },
      {
        title: "Business ",
        subTitle: "Outcome",
        goals: [
          "Increased Revenue",
          "Reduced Churn",
          "Improved Metrics",
          "Faster Time to Market",
        ],
      },
    ],
  },

  {
    images: [BD1, BD2],
    items: [
      {
        title: "Business",
        subTitle: "Strategy",
        goals: [
          "Business Goal",
          "Mission",
          "Target",
          "Value proposition",
          "SWOT analysis",
          "Business Model canvas",
        ],
      },
      {
        title: "Research",
        goals: [
          "Wireframe",
          "Visual Design",
          "Design System",
          "Clickable Prototypes",
          "Developer Handoff",
        ],
      },
      {
        title: "Build & Test",
        goals: [
          "Discovery Workshop",
          "No-code Development",
          "Front-end Development",
          "Back-end Development",
          "Quality assurance (QA)",
        ],
      },
      {
        title: "Launch",
        goals: [
          "Wireframe",
          "Clickable Prototypes",
          "Visual Design",
          "Design System",
        ],
      },
      {
        title: "Test & Iterate",
        goals: [
          "Quality Assurance (QA)",
          "Usability Testing",
          "User Feedback",
          "Implementation",
        ],
      },
      {
        title: "Maintenance",
        goals: ["Maintenance", "Maintenance", "Continues Support"],
      },
    ],
  },

  {
    images: [PD1, PD2],
    items: [
      {
        title: "Research and",
        subTitle: "Discovery",
        goals: [
          "Research",
          "Information gathering",
          "Target market",
          "Value proposition",
          "Competitive audit",
        ],
      },
      {
        title: "Brand Strategy",
        goals: [
          "Values Proposition",
          "Brand Strategy",
          "Brand Values",
          "Business Direction",
        ],
      },
      {
        title: "Design Development",
        goals: [
          "Visual designs",
          "Logo Sketches",
          "Design Placements",
          "Mockups",
          "Presentation",
          "Brand Guidelines",
        ],
      },
      {
        title: "Monitoring and Evaluation",
        goals: [
          "Client Feedback",
          "Iterations and refinement",
          "Brand reveal",
          "Brand assets handoff",
        ],
      },
    ],
  },

  {
    images: [AI1, AI2],
    items: [
      {
        title: "Market Research",
        goals: [
          "Market analysis",
          "User research",
          "Identify pain points",
          "Competitor analysis",
          "Trend analysis",
        ],
      },
      {
        title: "Conceptualization",
        goals: [
          "Ideation",
          "Brainstorming",
          "Concept validation",
          "Feasibility assessment",
          "Target audience alignment",
        ],
      },
      {
        title: "Prototype Development",
        goals: [
          "Prototyping",
          "Iterative design",
          "User testing",
          "Functionality validation",
          "User experience refinement",
        ],
      },
      {
        title: "Product Testing",
        goals: [
          "Quality assurance",
          "Performance testing",
          "User acceptance testing",
          "Bug fixing",
          "Scalability assessment",
        ],
      },
      {
        title: "Launch and Iteration",
        goals: [
          "Product launch",
          "Feedback collection",
          "Continuous improvement",
          "Feature updates",
          "Market adaptation",
        ],
      },
    ],
  },
];

export const processData = [
  // {
  //   id: 1,
  //   base: "Ui/Ux Design",
  //   shortTitle: "ui/ux Design Process",
  //   title: "Business-Driven",
  //   subTitle: "Design Process",
  //   items: [], // No item texts for this process
  // },

  {
    id: 3,
    base: "Branding",
    shortTitle: "Brand Process",
    title: "Brand Design",
    subTitle: "Visual Brand Identity Process",
    items: [], // No item texts for this process
  },

  {
    id: 5,
    base: "Social Media Management",
    shortTitle: "Social Media Management",
    title: "Social Media Management",
    subTitle: "SMM Process Flow",
    items: [
      "Client Onboarding",
      "Content Planning",
      "Content Creation",
      "Scheduling and Posting",
      "Audience Engagement",
      "Analytics and Reporting",
      "Adjustment and Optimization",
    ],

    Image1: SMM1,
    Image2: SMM2,
  },

  {
    id: 2,
    base: "Web Development",
    shortTitle: "Development Process",
    title: "Web Development & Design",
    subTitle: "Web Development Process",
    items: [], // No item texts for this process
  },

  {
    id: 6,
    base: "Data Analytics",
    shortTitle: "Data Analytics",
    title: "Data Analytics & Management Solution",
    subTitle: "Streamlining Data Processes",
    items: [
      "Data Collection and Assessment",
      "Data Cleaning and Transformation",
      "Data Modeling and Analysis",
      "Insights Generation and Visualization",
      "Data Governance and Security",
    ],

    Image1: QA1,
    Image2: QA2,
  },

  {
    id: 8,
    base: "DIgital Marketing",
    shortTitle: "Digital Marketing",
    title: "Digital Marketing",
    subTitle: "Business Process Flow",
    items: [
      "Client Consultation",
      "Campaign Strategy Development",
      "Content Creation and Design",
      "Campaign Deployment",
      "Analytics and Reporting",
    ],

    Image1: EM1,
    Image2: EM2,
  },

  // {
  //   id: 4,
  //   base: "Product Development",
  //   shortTitle: "Implementation Process",
  //   title: "Product Development",
  //   subTitle: "Implementation Process",
  //   items: [], // No item texts for this process
  // },

  // {
  //   id: 7,
  //   base: "Product Management",
  //   shortTitle: "Management Process",
  //   title: "Product Management",
  //   subTitle: "Management Process",
  //   items: ["Ideation", "Planning", "Design", "Development", "Launch"],
  //   Image1: PMAN1,
  //   Image2: PMAN2,
  // },

  // {
  //   id: 5,
  //   base: "SEO",
  //   shortTitle: "Search Engine Optimization",
  //   title: "Search Engine Optimization",
  //   subTitle: "SEO Process Flow",
  //   items: [
  //     "Client Consultation and Audit",
  //     "Keyword Research and Strategy",
  //     "On-Page and Off-Page Optimization",
  //     "Monitoring and Analytics",
  //     "Reporting and Continuous Improvement",
  //   ],

  //   Image1: SEO1,
  //   Image2: SEO2,
  // },

  // {
  //   id: 7,
  //   base: "Copy Writing",
  //   shortTitle: "Copy Writing",
  //   title: "Copy Writing",
  //   subTitle: "Business Process Flow",
  //   items: [
  //     "Briefing",
  //     "Proposal and Agreement",
  //     "Research",
  //     "Writing",
  //     "Review and Revisions",
  //     "Finalization",
  //     "Delivery",
  //   ],
  //   Image1: CW1,
  //   Image2: CW2,
  // },

  // {
  //   id: 8,
  //   base: "Quality Assurance",
  //   shortTitle: "Quality Assurance",
  //   title: "Quality Assurance",
  //   subTitle: "Business Process Flow",
  //   items: [
  //     "Needs Assessment and Proposal",
  //     "Agreement and Planning",
  //     "Execution and QA Processes",
  //     "Review and Optimization",
  //     "Finalization and Follow-up",
  //   ],

  //   Image1: QA1,
  //   Image2: QA2,
  // },

  // {
  //   id: 9,
  //   base: "Software Solution",
  //   shortTitle: "Software Solution",
  //   title: "Software Solution",
  //   subTitle: "Business Process Flow",
  //   items: [
  //     "Discovery",
  //     "Design",
  //     "Develop",
  //     "Deploy",
  //     "Support and Maintenance",
  //   ],
  //   Image1: SS1,
  //   Image2: SS2,
  // },

  // {
  //   id: 11,
  //   base: "Knowledge Management",
  //   shortTitle: "Knowledge Management",
  //   title: "Knowledge Management",
  //   subTitle: "Business Process Flow",
  //   items: [
  //     "Initial Consultation",
  //     "Needs Assessment",
  //     "Contract Agreement",
  //     "Execution and Implementation",
  //     "Quality Assurance and Handover",
  //   ],

  //   Image1: KM1,
  //   Image2: KM2,
  // },

  // {
  //   id: 12,
  //   base: "AI & ML Validation and Entry",
  //   shortTitle: "AI & ML Validation and Entry",
  //   title: "AI & ML Validation and Entry",
  //   subTitle: "Business Process Flow",
  //   items: [
  //     "Client Consultation",
  //     "Scope Definition",
  //     "Data Collection",
  //     "Validation and Entry",
  //     "Quality Assurance",
  //     "Client Review",
  //     "Finalization and Delivery",
  //   ],

  //   Image1: AI1,
  //   Image2: AI2,
  // },
];

export const processTagTexts = [
  // "Ui/Ux Design",
  "Branding & Product Design",
  "Social Media Management",
  "Web/Mobile app development",
  "Data Analytics & Management Solution",
  "Digital Marketing",
  // "Product Development",
  // "Product Management",
  // "Copy Writing",
  // "Quality Assurance",
  // "Software Solutions",
  // "Email Marketing",
  // "Knowledge Management",
  // "AI & ML Validation and Entry",
];

export const blogTagTexts = [
  "All Blogs",
  "UI Design",
  "UX Design",
  "Frontend Development",
  "Backend Development",
  "Product Design",
  "Mobile Development",
  "Web Development",
  "Software Development",
  "Business",
  "Marketing",
  "SEO",
  "Content Writing",
  "Product Management",
  "Project Management",
  "Freelancing",
];
